import clsx from 'clsx';
import { PageHeader, RedesignLayout, useSharedStyles } from '../shared';
import CircularProgress from '@material-ui/core/CircularProgress';
import CompassHero from './components/CompassHero';
import CompassSections from './components/CompassSections';
import HistoryButton from './components/HistoryButton';
import { useCompassPage } from './hooks/useCompassPage';
import locale from './locale.json';
import { useCompassStyles } from './index.styles';

const Compass = () => {
  const classes = useCompassStyles();
  const sharedClasses = useSharedStyles();
  const { loading, harmonyTestLastResult, canAccessNeeds, showNeeds, showNeedsPro } =
    useCompassPage();

  if (loading) {
    return (
      <RedesignLayout footer={true} noPadding={true}>
        <div className={sharedClasses.loadingCenter}>
          <CircularProgress />
        </div>
      </RedesignLayout>
    );
  }

  return (
    <RedesignLayout footer={true} noPadding={true}>
      <div className={clsx(sharedClasses.pageShell, classes.page)}>
        <PageHeader
          breadcrumbs={[{ label: locale.home, href: '/main' }, { label: locale.breadcrumbCurrent }]}
          title={locale.pageTitle}
          description={locale.pageDescription}
          titleVariant="primary"
          actions={<HistoryButton />}
        />

        <div className={classes.sectionsStack}>
          <CompassHero />
          <CompassSections
            harmonyTestLastResult={harmonyTestLastResult}
            loading={loading}
            canAccessNeeds={canAccessNeeds}
            showNeeds={showNeeds}
            showNeedsPro={showNeedsPro}
          />
        </div>
      </div>
    </RedesignLayout>
  );
};

export default Compass;
